import listIcon from './list.svg';
import orderIcon from './order.svg';
import priceIcon from './prices.svg';
import cartIcon from './cart.svg';

export const getIcon = (icon: string) => {
  switch (icon) {
    case 'catalog':
    case 'managers':
    case 'companies':
    case 'list':
      return listIcon;
    case 'orders':
    case 'order':
      return orderIcon;
    case 'prices':
      return priceIcon;
    case 'cart':
      return cartIcon;
    default:
      return listIcon;
  }
};
